import { useEffect, useState } from "react";
import {
  Container,
  ContainerRow,
  ContainerView,
} from "../../../components/Container";
import { Form } from "antd";
import { useApp } from "../../../contexts";
import {
  WalletConvertInfo,
  WalletConvertInfoItem,
  WalletConvertInfoItemTitle,
  WalletConvertInfoItemValue,
} from "../../wallet-detail/styles";
import {
  FormButton,
  FormInputNumberRaw,
  FormItemRow,
  FormSelect,
} from "../../../components/Form";
import {
  errorView,
  formatCurrency,
  getWalletList,
  getWithdrawFee,
  getDexWallet,
  ssoGetUserInfo,
  postTransferWeb3,
} from "../../../services/app";
import ModalTransferWeb3 from "../modal";
import produce from "immer";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { TitleWithBack } from "../../../components/Layout";
import {
  StepBody,
  StepHead,
  Steps,
  Step,
  WithdrawFormContainer,
} from "../styles";
import FormInput from "../../../components/FormCustom2/Input";
import { error, success } from "../../../Notification";

export default function TransferWeb3(props) {
  const {
    T,
    getCurrency,
    convertToBTC,
    convertToLocalCurrency,
    currencies,
    loadContextData,
    setAlert,
    cryptoCodes,
    setLoading,
  } = useApp();
  const [showSetPassword, setShowSetPassword] = useState(false);
  const navigate = useNavigate();
  let { code, walletId, type } = props || {};
  const params = useParams();
  const [searchParams] = useSearchParams();
  if (!code && searchParams.get("code")) {
    code = searchParams.get("code");
  }
  if (!walletId && searchParams.get("walletId")) {
    walletId = searchParams.get("walletId");
  }
  if (!type && searchParams.get("type")) {
    type = searchParams.get("type");
  }
  const [fee, setFee] = useState(0);
  const [form] = Form.useForm();
  const [modal, setModal] = useState(false);
  const [available, setAvailable] = useState(false);
  const [wallets, setWallets] = useState([]);
  const [wallet, setWallet] = useState(code);
  const [dexWallet, setDexWallet] = useState(null);
  const [errors, setErrors] = useState([]);
  // is option

  useEffect(() => {
    if (code) {
      form.setFieldsValue({
        coin: currencies.find((x) => x.code === code) ? code : "",
      });
      setWallet(code);
    }
    loadData();
  }, [code]);
  
  useEffect(() => {
    form.setFieldValue("to", dexWallet);
  }, [dexWallet]);

  const onBack = () => {
    navigate(-1);
  };
  const onSetPassword = () => {
    navigate(`/set-password`);
  };
  const loadData = async () => {
    setLoading(true);
    let result = await getWalletList();
    if (result.status === 200) {
      const items = result?.data?.data?.wallets?.rows || [];
      setWallets(items);
    }
    const resultDexWallet = await getDexWallet();
    console.log('loadData=>resultDexWallet=', resultDexWallet);
    if(resultDexWallet && resultDexWallet.data && resultDexWallet.data.data && resultDexWallet.data.data.public_address) {
      setDexWallet(resultDexWallet.data.data.public_address);
      console.log('loadData=>setDexWallet=', resultDexWallet.data.data.public_address);
    }
    setLoading(false);
  };

  const loadFee = async (amount) => {
    let result = await getWithdrawFee(amount, code);
    if (result?.status === 200) {
      setFee(result?.data?.data || 0);
    }
  };
  const checkUserHasPassword = async () => {
    try {
      let result = await ssoGetUserInfo();
      if (result?.data?.data?.has_password) {
        return true;
      }
      return false;
    } catch (err) {
      return false;
    }
  };
  const onConvert = async (values) => {
    const validatePassword = await checkUserHasPassword();
    if (!validatePassword) {
      setShowSetPassword(true);
      return;
    }
    setLoading(true);
    const result = await postTransferWeb3({
      fromWalletId: row?.id,
      amount: values.amount,
    });
    setLoading(false);
    if (result.status === 200) {
      setModal({
        ...(result?.data?.data || {}),
        ...(result?.data?.data?.dataValues || {}),
      });
      loadContextData();
    } else {
      setErrors(result?.data?.error?.validates || []);
      if (!(result?.data?.error?.validates || []).length) {
        error(
          result?.data?.error?.message ||
            T("Failed to create a transfer request")
        );
      }
    }
  };

  const convertData = () => {
    let itemWallet = wallets.find((item) => item.currency_code === wallet);
    const data = {
      wallets: wallets.map((item, index) => {
        return {
          ...item,
          coin: item.currency_code,
          amount: item.dog_food,
          btc: convertToBTC(item.dog_food, item.currency_code, getCurrency()),
          local: convertToLocalCurrency(
            item.dog_food,
            item.currency_code,
            getCurrency()
          ),
        };
      }),
      wallet: itemWallet
        ? {
            ...itemWallet,
            coin: itemWallet.currency_code,
            amount: itemWallet.dog_food,
            btc: convertToBTC(
              itemWallet.dog_food,
              itemWallet.currency_code,
              getCurrency()
            ),
            local: convertToLocalCurrency(
              itemWallet.dog_food,
              itemWallet.currency_code,
              getCurrency()
            ),
          }
        : {},
    };
    /* if (form) {
      form.setFieldValue("amount", data?.wallet?.amount || 0);
      loadFee(data?.wallet?.amount);
    } */
    return data;
  };

  const onUpdateData = () => {
    const values = form.getFieldsValue();
    console.log('onUpdateData=>values.amount', values.amount);
    if (values.amount) {
      loadFee(values.amount);
    }
    setAvailable(values.amount && values.to);
  };

  const onTransactionHistory = () => {
    let codeOrigin = code;
    let idOrigin = walletId;
    if (row.currency_code) {
      codeOrigin = row.currency_code;
    }
    if (row.id) {
      idOrigin = row.id;
    }
    navigate(`/wallet-detail/${type}?code=${codeOrigin || ""}&walletId=${idOrigin}`);
  };

  const rows = convertData().wallets || [];
  const row = convertData().wallet || {};
  
  return rows?.length ? (
    <Container>
      <ContainerView>
        <TitleWithBack title={T("Transfer To Web3 Request")} onClick={onBack} />
        <Steps>
          <Step>
            <div>
              <StepHead>
                <img src="/assets/images/otc/step2.svg" />
                <span>{T("Enter Information")}</span>
              </StepHead>
              <StepBody>{T("Enter the amount you want to transfer")}</StepBody>
            </div>
            <div className={"arrow"} />
          </Step>
          <Step>
            <div>
              <StepHead>
                <img src="/assets/images/otc/step3.svg" />
                <span>{T("Wait for Approval")}</span>
              </StepHead>
              <StepBody>
                {T("Please wait while we review your request")}
              </StepBody>
            </div>
            <div className={"arrow"} />
          </Step>
          <Step>
            <div>
              <StepHead>
                <img src="/assets/images/otc/step4.svg" />
                <span>{T("Receive Result")}</span>
              </StepHead>
              <StepBody>
                {T("Deposit successfully sent to recipient’s address")}
              </StepBody>
            </div>
          </Step>
        </Steps>

        <WithdrawFormContainer>
          <Form
            form={form}
            onFinish={(values) => {
              onConvert(form.getFieldsValue());
            }}
            onValuesChange={() => {
              onUpdateData();
            }}
          >
            <FormItemRow
              {...errorView(errors, "destWalletAddress")}
              name={"to"}
              label={T("Address")}
              rules={[{ required: true, message: "" }]}
            >
              <FormInput
                readOnly
                placeholder={T("Please enter the recipient’s address")}
              />
            </FormItemRow>
            <FormItemRow
              {...errorView(errors, "amount")}
              name={"amount"}
              label={T("Amount")}
              rules={[{ required: true, message: T("Amount is required!") }]}
            >
              <FormInputNumberRaw
                onChange={() => {
                  setErrors(
                    produce((draft) => {
                      draft.splice(
                        draft.findIndex((item) => item.key === "amount"),
                        1
                      );
                    })
                  );
                }}
                min={0}
                onAll={() => {
                  form.setFieldValue("amount", parseFloat(row?.amount));
                  setErrors(
                    produce((draft) => {
                      draft.splice(
                        draft.findIndex((item) => item.key === "amount"),
                        1
                      );
                    })
                  );
                  onUpdateData();
                }}
                addonAfter={row?.coin || ""}
                placeholder={T(`Please enter the {coin} amount`).replace(
                  "{coin}",
                  row?.coin || ""
                )}
              />
            </FormItemRow>

            <ContainerRow style={{ marginTop: 41, marginBottom: 41 }}>
              <WalletConvertInfo style={{ flex: 1 }}>
                <WalletConvertInfoItem>
                  <WalletConvertInfoItemTitle>
                    {T("Balance")}
                  </WalletConvertInfoItemTitle>
                  <WalletConvertInfoItemValue
                    style={{ marginLeft: 0 }}
                    className={"text-aia-red"}
                  >
                    {formatCurrency(row?.amount || 0)} {row?.coin}
                  </WalletConvertInfoItemValue>
                </WalletConvertInfoItem>
                <WalletConvertInfoItem>
                  <WalletConvertInfoItemTitle>
                    {T("Fee")}
                  </WalletConvertInfoItemTitle>
                  <WalletConvertInfoItemValue>
                    {formatCurrency(fee)} {row?.coin}
                  </WalletConvertInfoItemValue>
                </WalletConvertInfoItem>
              </WalletConvertInfo>
            </ContainerRow>

            <Container>
              <FormButton
                disabled={!available}
                htmlType={"button"}
                onClick={() => {
                  form.submit();
                }}
              >
                {T("Withdraw")}
              </FormButton>
            </Container>
          </Form>
        </WithdrawFormContainer>
      </ContainerView>

      {modal ? (
        <ModalTransferWeb3
          onClose={(value) => {
            setModal(null);
            if (value) {
              value === "success"
                ? success(T("Transfer request has been created"))
                : error(T("Failed to create a trasfer request"));
              if (value === "success") {
                setAvailable(false);
                form.resetFields();
                onTransactionHistory();
              }
            }
            loadData();
          }}
          value={modal}
        />
      ) : null}
      {showSetPassword && (
        <ModalPasswordRequired
          onClose={() => setShowSetPassword(false)}
          onSubmit={() => onSetPassword()}
        />
      )}
    </Container>
  ) : null;
}
